import React, { useEffect, useState } from "react";

export default function PaisSelect({ selectedPais, setSelectedPais, strRuc, intTipo }) {
  const [paises, setPaises] = useState([]);

  useEffect(() => {
    if (strRuc && intTipo) {  // Solo llama a la API si existen strRuc e intTipo
      fetch(`https://msoftperu.azurewebsites.net/home/GetPais?strRuc=${strRuc}&intTipo=${intTipo}`)
        .then((response) => response.json())
        .then((data) => setPaises(data))
        .catch((error) => console.error("Error fetching paises:", error));
    }
  }, [strRuc, intTipo]);

  return (
    <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0">
      <label className="font-semibold mr-2">País:</label>
      <select
        className="border border-gray-400 rounded-lg p-2 text-lg"
        value={selectedPais}
        onChange={(e) => setSelectedPais(e.target.value)}
      >
        {/* Opción Todos */}
        <option value="">Todos</option>

        {/* Mostrar los países cargados */}
        {paises.map((pais) => (
          <option key={pais.ID_TABLA} value={pais.ID_TABLA}>
            {pais.DESCRIPCION}
          </option>
        ))}
      </select>
    </div>
  );
}
